import {
  ChangeDetectionStrategy,
  Component,
  PLATFORM_ID,
  OnInit,
  ViewEncapsulation,
  inject,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { DOCUMENT, isPlatformBrowser } from "@angular/common";
import { fromEvent, Observable } from "rxjs";
import {
  debounceTime,
  map,
  distinctUntilChanged,
  startWith,
  tap,
} from "rxjs/operators";

/*
 * Font awesome
 */
import { FaIconLibrary } from "@fortawesome/angular-fontawesome";
// import { fab } from '@fortawesome/free-brands-svg-icons';
// import { far } from '@fortawesome/free-regular-svg-icons';
// import { fas } from '@fortawesome/free-solid-svg-icons';

import {
  faFacebookF as fabFacebookF,
  faGoogle as fabGoogle,
  faInstagram as fabInstagram,
  faPinterestP as fabPinterestP,
} from "@fortawesome/free-brands-svg-icons";

import {
  faArrowUp as fasArrowUp,
  faArrowLeft as fasArrowLeft,
  faBars as fasBars,
  faCalendarAlt as fasCalendarAlt,
  faCalendarTimes as fasCalendarTimes,
  faChevronLeft as fasChevronLeft,
  faChevronRight as fasChevronRight,
  faCirclePlay as fasCirclePlay,
  faClose as fasClose,
  faCog as fasCog,
  faEnvelope as fasEnvelope,
  faHeart as fasHeart,
  faMaximize as fasMaximize,
  faMinimize as fasMinimize,
  faPhone as fasPhone,
  faSquare as fasSquare,
  faThLarge as fasThLarge,
  faThList as fasThList,
  faSearch as fasSearch,
  faFrown as fasFrown,
  faArrowTurnUp as fasArrowTurnUp,
  faArrowTurnDown as fasArrowTurnDown,
  faFolder as fasFolder,
  faTextSlash as fasTextSlash,
  faMoon as fasMoon,
  faSun as fasSun,
  faTableCells as fasTableCells,
  faTableCellsLarge as fasTableCellsLarge,
} from "@fortawesome/free-solid-svg-icons";

import {
  faCalendar as farCalendar,
  faCircleQuestion as farCircleQuestion,
} from "@fortawesome/free-regular-svg-icons";

import { CoreActions, CatalogueActions } from "./core/store/actions";
import { CoreSelectors } from "./core/store/selectors";
import { CheckForUpdate } from "./core/services/check-for-update.service";
import { LogUpdate } from "./core/services/log-update.service";
import { PromptUpdate } from "./core/services/prompt-update.service";
import { Screen } from "./core/models/screen.model";
import { LayoutComponent } from "./core/components/layout/layout.component";

@Component({
  selector: "audio-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.sass"],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [LayoutComponent],

  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  private checkForUpdate = inject(CheckForUpdate);
  private logUpdate = inject(LogUpdate);
  private promptUpdateService = inject(PromptUpdate);
  private platformId = inject(PLATFORM_ID);
  private doc = inject(DOCUMENT);
  private store = inject<Store>(Store);

  screen$: Observable<Screen>;

  constructor() {
    const library = inject(FaIconLibrary);
    library.addIcons(
      fabFacebookF,
      fabGoogle,
      fabInstagram,
      fabPinterestP,
      farCalendar,
      farCircleQuestion,
      fasArrowUp,
      fasArrowLeft,
      fasBars,
      fasCalendarAlt,
      fasCalendarTimes,
      fasChevronLeft,
      fasChevronRight,
      fasCirclePlay,
      fasClose,
      fasCog,
      fasEnvelope,
      fasHeart,
      fasMaximize,
      fasMinimize,
      fasPhone,
      fasSquare,
      fasThLarge,
      fasThList,
      fasSearch,
      fasFrown,
      fasArrowTurnUp,
      fasArrowTurnDown,
      fasFolder,
      fasTextSlash,
      fasMoon,
      fasSun,
      fasTableCells,
      fasTableCellsLarge,
    );

    this.screen$ = this.store.select(CoreSelectors.getScreen);

    if (isPlatformBrowser(this.platformId)) {
      fromEvent(window, "resize")
        .pipe(
          debounceTime(100),
          map(() => window.innerWidth),
          distinctUntilChanged(),
          startWith(window.innerWidth),
          tap((width) => {
            this.store.dispatch(new CoreActions.SetScreen(width));
          }),
        )
        .subscribe();

      // <!-- Elfsight widgets -->
      const script = this.doc.createElement("script");
      script.setAttribute("src", `https://apps.elfsight.com/p/platform.js`);
      this.doc.head.appendChild(script);
    }
  }

  ngOnInit(): void {
    this.store.dispatch(new CatalogueActions.ListAttempt());
  }
}
